import { makeStyles } from "@material-ui/core";

const partnersListStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  titleActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 8,
    flexWrap: "wrap",
  },
  resetFiltersButton: {
    minWidth: 120,
    height: 38,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 700,
    borderColor: "#d8e2ef",
    color: "#4b6488",
    backgroundColor: "#ffffff",
  },
  filterToggleButton: {
    minWidth: 165,
    height: 38,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 700,
    borderColor: "#c7d7eb",
    marginLeft: "12px !important",
    color: "#2563eb",
    backgroundColor: "#f8fbff",
  },
  filtersPaper: {
    border: "1px solid #dbe6f3",
    borderRadius: 12,
    padding: 14,
    marginBottom: 2,
    backgroundColor: "#ffffff",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
  },
  filtersHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  filtersTitle: {
    fontSize: 13,
    fontWeight: 800,
    color: "#1f2a44",
  },
  filtersSubtitle: {
    marginTop: 2,
    fontSize: 11,
    color: "#64748b",
  },
  filtersHeaderButton: {
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 700,
    color: "#2563eb",
  },
  filtersBar: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
    marginTop: 14,
    paddingTop: 14,
    borderTop: "1px solid #eef3fa",
  },
  filterModesRow: {
    display: "flex",
    alignItems: "stretch",
    gap: 12,
    flexWrap: "nowrap",
    "@media (max-width: 900px)": {
      flexDirection: "column",
    },
  },
  dateRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    border: "1px solid #eef3fa",
    borderRadius: 8,
    padding: "10px 12px",
    backgroundColor: "#f8fbff",
    flex: 1,
    minWidth: 0,
  },
  dateLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#4b6488",
    minWidth: 140,
  },
  dateInput: {
    minWidth: 170,
  },
  groupBar: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    padding: "10px 12px",
    border: "1px solid #eef3fa",
    borderRadius: 8,
    backgroundColor: "#fbfdff",
    flex: "0 0 220px",
    minWidth: 220,
    "@media (max-width: 900px)": {
      flexBasis: "auto",
      width: "100%",
    },
  },
  autocomplete: {
    minWidth: 180,
    width: "100%",
  },
  smallAutocompleteListbox: {
    "& .MuiAutocomplete-option": {
      fontSize: 13,
      minHeight: 30,
    },
  },
  filterButton: {
    minWidth: 110,
    height: 40,
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 600,
  },
  paper: {
    border: '1px solid #dbe6f3',
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
  },
  grid: {
    border: "none",
    minWidth: 860,
    "& .MuiDataGrid-toolbarContainer": {
      justifyContent: "flex-end",
      padding: "8px 12px",
      gap: 8,
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#f8fbff",
      borderBottom: "1px solid #dbe6f3",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: 10,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.4px",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "1px solid #eef3fa",
      fontSize: 12,
      color: "#4b6488",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#f6faff",
    },
    "& .partner-group-row": {
      backgroundColor: "#e8eef7",
    },
    "& .partner-group-row:hover": {
      backgroundColor: "#e8eef7",
    },
  },
  groupGridLabel: {
    fontSize: 12,
    fontWeight: 800,
    color: "#1f2a44",
  },
  partnerCell: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 4,
    minWidth: 0,
    width: "100%",
    padding: "2px 0",
  },
  partnerMainLine: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    minWidth: 0,
    width: "100%",
    flexWrap: "wrap",
  },
  partnerName: {
    fontWeight: "bold",
    fontSize: 12,
    color: "#1f2a44",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    lineHeight: 1.3,
  },
  partnerPid: {
    fontFamily: "'DM Mono', monospace",
    fontSize: 9,
    color: "#64748b",
    marginTop: 0,
    opacity: 0.85,
    lineHeight: 1.2,
    display: "block",
  },
  badge: {
    display: "inline-block",
    padding: "2px 7px",
    borderRadius: 4,
    fontSize: 8,
    // fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.4px",
    whiteSpace: "nowrap",
    lineHeight: 1.35,
  },
  badgeCI: {
    background: "rgba(192,132,252,.15)",
    color: "#9333ea",
  },
  badgeMulti: {
    background: "rgba(251,191,36,.15)",
    color: "#d97706",
  },
  badgeLegal: {
    background: "rgba(79,142,247,.16)",
    color: "#2563eb",
  },
  badgeSituationEncours: {
    background: "rgba(52,211,153,.15)",
    color: "#16a34a",
  },
  badgeSituationFin: {
    background: "rgba(75,96,128,.2)",
    color: "#64748b",
  },
  badgeSituationResilie: {
    background: "rgba(248,113,113,.15)",
    color: "#dc2626",
  },
  badgeEvalGood: {
    background: "rgba(52,211,153,.15)",
    color: "#16a34a",
  },
  badgeEvalAverage: {
    background: "rgba(251,191,36,.15)",
    color: "#d97706",
  },
  badgeEvalPoor: {
    background: "rgba(248,113,113,.15)",
    color: "#dc2626",
  },
  badgeEvalAcceptable: {
    background: "rgba(79,142,247,.16)",
    color: "#2563eb",
  },
  badgeMissing: {
    background: "rgba(248,113,113,.1)",
    color: "#dc2626",
    border: "1px dashed #dc2626",
  },
  monoCell: {
    fontFamily: "'DM Mono', monospace",
    color: "#4b6488",
  },
  ficheButton: {
    border: "1px solid rgba(79,142,247,.35)!important",
    // boxShadow: "rgba(79,142,247,.2) 0px 1px 2px, rgba(79,142,247,.15) 0px 2px 4px, rgba(79,142,247,.1) 0px 4px 8px",
    borderRadius: 6,
    color: "#2563eb",
    padding: 4,
    "&:hover": {
      backgroundColor: "rgba(79,142,247,.12)",
    },
  },
  smallAutopComplete: {
    '& .MuiFormLabel-root': {
      fontSize: 13,
    },
    '& .MuiInputBase-input': {
      fontSize: 13,
    },
    '& .MuiChip-label': {
      fontSize: 10,
    },
    '& .MuiAutocomplete-tag': {
      height: 20,
    },
  },
  tableHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 14px',
    borderBottom: '1px solid #dbe6f3',
    backgroundColor: '#f8fbff',
    gap: 10,
    flexWrap: 'wrap',
  },
  tableTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: '#1f2a44',
  },
  tableRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
  },
  tableCount: {
    fontSize: 12,
    color: '#4b6488',
    fontFamily: "'DM Mono', monospace",
  },
  exportButton: {
    textTransform: 'none',
    borderRadius: 8,
    fontWeight: 600,
  },
  "@media (max-width: 720px)": {
    titleRow: {
      alignItems: "stretch",
    },
    titleActions: {
      width: "100%",
      justifyContent: "stretch",
    },
    filterToggleButton: {
      flex: 1,
      minWidth: 0,
    },
    resetFiltersButton: {
      flex: 1,
      minWidth: 0,
    },
    filtersPaper: {
      padding: 12,
      borderRadius: 10,
    },
    filtersHeader: {
      alignItems: "flex-start",
    },
    filtersHeaderButton: {
      paddingLeft: 0,
    },
    groupBar: {
      alignItems: "stretch",
    },
    dateRow: {
      alignItems: "stretch",
    },
    dateLabel: {
      width: "100%",
      minWidth: 0,
    },
    dateInput: {
      width: "100%",
      minWidth: 0,
    },
    tableHeader: {
      alignItems: "flex-start",
    },
    tableRight: {
      width: "100%",
      justifyContent: "space-between",
    },
    paper: {
      overflowX: "auto",
    },
  },
}));

export default partnersListStyles;
